// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__35KFK","content":"GlobalSearch_content__35n1n"};